var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "fs-6 fw-bold" }, [
      _vm._v(_vm._s(_vm.userExam.examName)),
    ]),
    _vm._v(" "),
    _vm.userExam
      ? _c("div", { staticClass: "d-flex mt-4" }, [
          !_vm.userExam.examHideResult
            ? _c("div", { staticClass: "col p-0" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", {}, [
                    _c(
                      "span",
                      {
                        staticClass: "text-h4",
                        attrs: { "data-v-cdc1d34a": "" },
                      },
                      [_vm._v(_vm._s(_vm.userExam.average))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "text-caption",
                        attrs: { "data-v-cdc1d34a": "" },
                      },
                      [_vm._v("%")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "col-12 p-0 m-0 text-caption" }, [
                      _vm._v("スコア"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ps-3" }, [
                    _c(
                      "span",
                      {
                        staticClass: "text-h4",
                        attrs: { "data-v-cdc1d34a": "" },
                      },
                      [_vm._v(_vm._s(_vm.userExam.position))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "text-caption",
                        attrs: { "data-v-cdc1d34a": "" },
                      },
                      [
                        _vm._v(
                          "位（" +
                            _vm._s(_vm.userExam.userExamsCount) +
                            "人中）"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "col-12 p-0 m-0 text-caption" }, [
                      _vm._v("ランキング"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-borderless w-100 mt-5 mb-0" },
                  [
                    _c(
                      "tbody",
                      _vm._l(_vm.userExam.examSkills, function (skill, index) {
                        return _c(
                          "tr",
                          { key: index, staticClass: "text-caption" },
                          [
                            _c(
                              "th",
                              {
                                staticClass: "fw-bold py-1 px-0",
                                staticStyle: { width: "7.6em" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(skill.name) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "py-1 px-0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "v-progress-linear theme--light",
                                  staticStyle: { height: "15px" },
                                  attrs: {
                                    role: "progressbar",
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100",
                                    "aria-valuenow": skill.getSkillScore(
                                      _vm.userExam
                                    ),
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "v-progress-linear__background primary",
                                    style: {
                                      opacity: 0.3,
                                      left:
                                        skill.getSkillScore(_vm.userExam) + "%",
                                      width:
                                        100 -
                                        skill.getSkillScore(_vm.userExam) +
                                        "%",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "v-progress-linear__buffer",
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "v-progress-linear__determinate primary",
                                    style: {
                                      width:
                                        skill.getSkillScore(_vm.userExam) + "%",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-progress-linear__content justify-content-end",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            skill.getSkillScore(_vm.userExam)
                                          ) +
                                          "% "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ms-3 d-flex flex-column justify-space-between" },
            [
              !_vm.userExam.examHideResult
                ? _c(
                    "div",
                    {
                      staticClass: "p-2 rounded-3 warning darken-1 text-white",
                    },
                    [
                      _vm.userExam.useExamEvaluation &&
                      _vm.userExam.examEvaluations.length > 0
                        ? _c(
                            "div",
                            [
                              _c("ExamEvaluationComponent", {
                                attrs: {
                                  examEvaluations: _vm.userExam.examEvaluations,
                                  score: _vm.userExam.average,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "text-caption text-center mb-0" },
                        [_vm._v("\n          予想合格率\n        ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "text-end" }, [
                _c(
                  "a",
                  {
                    staticClass: "small text-decoration-none",
                    on: { click: _vm.gotoExamResult },
                  },
                  [_vm._v("詳細")]
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }